export default "__VITE_ASSET__C8K8vv6j__"